import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { initMetaPixel, trackPageView } from '../utils/metaPixel';

/**
 * Loads the Meta Pixel once and fires a PageView on every route change
 * (the funnel is a SPA, so each page is a client-side navigation).
 */
export function MetaPixel() {
  const {
    pathname
  } = useLocation();
  const ready = useRef(false);
  if (!ready.current) {
    initMetaPixel();
    ready.current = true;
  }
  useEffect(() => {
    trackPageView();
  }, [pathname]);
  return null;
}